import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Divider,
  useTheme,
  Grid,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import api from "../../../services/api/api";

const NoticiaDetalhe = () => {
  const theme = useTheme();
  const { id } = useParams();
  const [noticia, setNoticia] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openImage, setOpenImage] = useState(null);

  useEffect(() => {
    const fetchNoticia = async () => {
      try {
        const response = await api.get(`/api/getNewsById/${id}`);
        console.log(response.data);
        setNoticia(response.data);
      } catch (error) {
        console.error("Erro ao buscar notícia:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNoticia();
  }, [id]);

  if (loading) return <Typography>Carregando...</Typography>;
  if (!noticia) return <Typography>Notícia não encontrada.</Typography>;

  return (
    <Box sx={{ padding: 4, width: 1200, margin: "0 auto" }}>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
          padding: 2,
          borderRadius: 1,
          marginBottom: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          NOTÍCIA
        </Typography>
      </Box>

      <Card sx={{ borderRadius: 2, boxShadow: 3, overflow: "hidden" }}>
        <CardMedia
          component="img"
          height="400"
          image={noticia.CapaImage}
          alt={noticia.title}
          onClick={() => setOpenImage(noticia.CapaImage)}
          sx={{ cursor: "pointer" }}
        />
        <CardContent sx={{ padding: 3 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ marginBottom: 1 }}
          >
            {new Date(noticia.createdAt).toLocaleDateString()} • {noticia.category}
          </Typography>
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ marginBottom: 3, textTransform: "uppercase" }}
          >
            {noticia.title}
          </Typography>
          <Divider sx={{ marginY: 2 }} />
          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.8,
              color: "text.primary",
              marginBottom: 2,
            }}
            dangerouslySetInnerHTML={{ __html: noticia.content }}
          />
        </CardContent>

        {noticia.OthersImages && noticia.OthersImages.length > 0 && (
          <CardContent>
            <Typography variant="h6" sx={{ marginBottom: 2, fontWeight: "bold" }}>
              Imagens Relacionadas
            </Typography>
            <Grid container spacing={2}>
              {noticia.OthersImages.map((image, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card sx={{ boxShadow: 2 }}>
                    <CardMedia
                      component="img"
                      height="200"
                      image={image}
                      alt={`Imagem ${index + 1}`}
                      onClick={() => setOpenImage(image)}
                      sx={{ cursor: "pointer" }}
                    />
                  </Card>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        )}
      </Card>

      <Dialog open={Boolean(openImage)} onClose={() => setOpenImage(null)}>
        <DialogContent sx={{ position: "relative", padding: 0 }}>
          <IconButton
            sx={{ position: "absolute", top: 10, right: 10, color: "white" }}
            onClick={() => setOpenImage(null)}
          >
            <CloseIcon />
          </IconButton>
          <img src={openImage} alt="Visualização" style={{ width: "100%", height: "auto" }} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default NoticiaDetalhe;